
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexBLeGKwecQK8yvprcjqWjaibkdxTV4aSvYoVyJLzRZa4Meta } from "/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/index.vue?macro=true";
import { default as agbw3lFhJq3LR7qY0zb7CpxMoHdypbSrqXFREN7KOlQFXMMeta } from "/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/agb.vue?macro=true";
import { default as cart858G8MV_ciszpPl_45X_456Ttg5eMUhmpAhd7yy0czTV5nwMeta } from "/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/cart.vue?macro=true";
import { default as test1oBOrtJs0fH_45FttSfstas4aCWRStBYp9OVFX8hwHHsEMeta } from "/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/test.vue?macro=true";
import { default as loginc5SFqLcDW0R1z9oLv536pU6Yl_45T4ThjALHwirbJMd4gMeta } from "/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/login.vue?macro=true";
import { default as searchWslS7fL7Oy2YUv5_e6dq5nuHI226hZhQOXeOepcf7rYMeta } from "/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/search.vue?macro=true";
import { default as barcode_DGUVGXuotZOEcmsn9Snc_452s_dcZRTqCBcrFMFPp7YUMeta } from "/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/barcode.vue?macro=true";
import { default as indexG0ccNzubwAUXCDswNT4ozpH7SPsY8PsQHFKywq00jxQMeta } from "/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/c/index.vue?macro=true";
import { default as imprint71qypTYtBc3Ic_80U98xOqEU0RfwswY2yx0AXjYLZzEMeta } from "/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/imprint.vue?macro=true";
import { default as welcomeDUPMzS8BwkYMnVrp0orZWYOSpn_45xNLZyla1LSRzSfO0Meta } from "/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/welcome.vue?macro=true";
import { default as registeraY3oxUg8IyHkqpeqybP1GRdyYY4fSjkfYATUje6rZGAMeta } from "/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/register.vue?macro=true";
import { default as campaignsNmd6WuNpr5G1JgGVn5KV20dkf9DSMPH_45ZkUkNG1ZtVsMeta } from "/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/campaigns.vue?macro=true";
import { default as suppliersPV7R7IjtwKPaVmQQlBk9vshNUFtcC4qicvIbrv_45hSYMMeta } from "/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/suppliers.vue?macro=true";
import { default as gutscheiner9mZFQnOuDVRETXIMQti_45hiuDEePY6ILftRJu2uhyWQMeta } from "/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/gutscheine.vue?macro=true";
import { default as _91_46_46_46slug_93W3y0W0OoKgVRvZrj5DvVjvLaodRZHzZ2ztaeTudzpcMMeta } from "/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/c/[...slug].vue?macro=true";
import { default as ims6ylCxuvkDX7NVqgQc6EygMxNdG5R49KUMeP4q_45FqqSYMeta } from "/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/campaign/ims.vue?macro=true";
import { default as datasecurityzuEdVrb7nsZgphF2c4ZaOkV95nQj1ZKJ1IkBhI_45VF_45UMeta } from "/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/datasecurity.vue?macro=true";
import { default as _91_46_46_46fallback_93L6DDBjPIlSnzFeogg2rq2wROjULnmv7xlAbsS7us6AQMeta } from "/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/[...fallback].vue?macro=true";
import { default as heelFHh_Tuy1gH75Q8fhRZr92VQ3pTYAkYMaX_45N_p12S0ZQMeta } from "/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/campaign/heel.vue?macro=true";
import { default as hybrid_45searchLQtuDiwtc_45CJSjcazX1CdDU5nUw7olJuH3byw_tJUZ4Meta } from "/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/hybrid-search.vue?macro=true";
import { default as order_45historyeOjy2A_gUtPw5d7CVYR1gL9WvefpWcxftLgNgKoQsOMMeta } from "/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/order-history.vue?macro=true";
import { default as _91id_93VfZt1YHSzQkzYa5vAq_16pPjJj5MTHrP7IpjA8eJOPsMeta } from "/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/s/orders/[id].vue?macro=true";
import { default as _91id_93Ssj5Z8DVMWnm_45B_FTgtXMiNH3dcf_LNUcl_2F3UPsXAMeta } from "/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/supplier/[id].vue?macro=true";
import { default as hillsf31UG3z877OU6aydC_4516lub6cam5s9FuM8UbICDLPtsMeta } from "/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/campaign/hills.vue?macro=true";
import { default as reset_45passwordIuBeOF7UeEPo6ocQ_45JZJTEMNHznKS7C_45j09hi2CjtAUMeta } from "/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/reset-password.vue?macro=true";
import { default as profileu9nNpdn7WyO4te18Sd6wH27AaG0hqjsq59ybAhSlMxYMeta } from "/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/account/profile.vue?macro=true";
import { default as tessieb280MR3BX8hp8SNFia3l9C4ZngBau8m58R_45yYvh5XyQMeta } from "/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/campaign/tessie.vue?macro=true";
import { default as forgot_45passwordBrE8DfLG4muBQPIn2F5_r5NfrL3HhMFlIs_15I9ZaOkMeta } from "/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/forgot-password.vue?macro=true";
import { default as product_45favoritesjPoYwjLYiOfpGIdFqo8spcKjVfyAew4sJx0nIO6JbJEMeta } from "/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/product-favorites.vue?macro=true";
import { default as references14hKF4c9x4KtiJsgq2XRqKcNn9uzwgp5yP_45FWgVQ_45PEMeta } from "/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/account/references.vue?macro=true";
import { default as dehinexxa_45Rs1XOvAyNQtRw7loaVbf6JLdq3razC0_45V99596SjX0Meta } from "/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/campaign/dehinexxa.vue?macro=true";
import { default as indexHZNxFXVUC3W8nyDimd6fbyG86czmf8BLEquc_AEVdFYMeta } from "/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/clinic-chain/index.vue?macro=true";
import { default as _91id_93_45hZx5NyrR1_sSTQPwpsEYgKUmS_6OhgdWqKWbR2f6c4Meta } from "/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/order-confirm/[id].vue?macro=true";
import { default as domespharma2nBZUb50oDFW5D8NEtPuByla98SqR6_QCPuo6QM8NQQcMeta } from "/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/campaign/domespharma2.vue?macro=true";
import { default as domespharma3oHZ0cutLV2H6zRXgZK0hiGu0_45ALXXh_45uxlPC5RatEg0Meta } from "/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/campaign/domespharma3.vue?macro=true";
import { default as domespharma4lE2mVDh4ttE1NrZbCW576oTFjG8P2h74SdzsHCpLh1MMeta } from "/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/campaign/domespharma4.vue?macro=true";
import { default as hybrid_45search_45stagingHC0rELwWxwMZxgh2i0345oXlmZOirGUreMT3pWUJD8MMeta } from "/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/hybrid-search-staging.vue?macro=true";
import { default as _91_46_46_46fallback_93VQE8_wkYi1C5zByz6AyriJ6VGo_456ghPNLEHguVOVTSAMeta } from "/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/[country]/[...fallback].vue?macro=true";
import { default as _91id_93JScHRPnUpAFRUm4_G_45AAhlA11mNv7Lq8xNK_459SeqYeMMeta } from "/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/product/[supplier]/[id].vue?macro=true";
import { default as affiliation7SbgaERsXbH3O_451uoyXxp4mAFfsh5L80TkVoZ5v9X4cMeta } from "/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/clinic-chain/affiliation.vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    meta: indexBLeGKwecQK8yvprcjqWjaibkdxTV4aSvYoVyJLzRZa4Meta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/index.vue")
  },
  {
    name: "agb___de",
    path: "/de/agb",
    meta: agbw3lFhJq3LR7qY0zb7CpxMoHdypbSrqXFREN7KOlQFXMMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/agb.vue")
  },
  {
    name: "agb___en",
    path: "/en/agb",
    meta: agbw3lFhJq3LR7qY0zb7CpxMoHdypbSrqXFREN7KOlQFXMMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/agb.vue")
  },
  {
    name: "agb___fr",
    path: "/fr/agb",
    meta: agbw3lFhJq3LR7qY0zb7CpxMoHdypbSrqXFREN7KOlQFXMMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/agb.vue")
  },
  {
    name: "cart___de",
    path: "/de/cart",
    meta: cart858G8MV_ciszpPl_45X_456Ttg5eMUhmpAhd7yy0czTV5nwMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/cart.vue")
  },
  {
    name: "cart___en",
    path: "/en/cart",
    meta: cart858G8MV_ciszpPl_45X_456Ttg5eMUhmpAhd7yy0czTV5nwMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/cart.vue")
  },
  {
    name: "cart___fr",
    path: "/fr/cart",
    meta: cart858G8MV_ciszpPl_45X_456Ttg5eMUhmpAhd7yy0czTV5nwMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/cart.vue")
  },
  {
    name: "test___de",
    path: "/de/test",
    meta: test1oBOrtJs0fH_45FttSfstas4aCWRStBYp9OVFX8hwHHsEMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/test.vue")
  },
  {
    name: "test___en",
    path: "/en/test",
    meta: test1oBOrtJs0fH_45FttSfstas4aCWRStBYp9OVFX8hwHHsEMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/test.vue")
  },
  {
    name: "test___fr",
    path: "/fr/test",
    meta: test1oBOrtJs0fH_45FttSfstas4aCWRStBYp9OVFX8hwHHsEMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/test.vue")
  },
  {
    name: "index___de",
    path: "/de",
    meta: indexBLeGKwecQK8yvprcjqWjaibkdxTV4aSvYoVyJLzRZa4Meta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/index.vue")
  },
  {
    name: "index___en",
    path: "/en",
    meta: indexBLeGKwecQK8yvprcjqWjaibkdxTV4aSvYoVyJLzRZa4Meta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/index.vue")
  },
  {
    name: "index___fr",
    path: "/fr",
    meta: indexBLeGKwecQK8yvprcjqWjaibkdxTV4aSvYoVyJLzRZa4Meta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/index.vue")
  },
  {
    name: "login___de",
    path: "/de/login",
    meta: loginc5SFqLcDW0R1z9oLv536pU6Yl_45T4ThjALHwirbJMd4gMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/login.vue")
  },
  {
    name: "login___en",
    path: "/en/login",
    meta: loginc5SFqLcDW0R1z9oLv536pU6Yl_45T4ThjALHwirbJMd4gMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/login.vue")
  },
  {
    name: "login___fr",
    path: "/fr/login",
    meta: loginc5SFqLcDW0R1z9oLv536pU6Yl_45T4ThjALHwirbJMd4gMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/login.vue")
  },
  {
    name: "search___de",
    path: "/de/search",
    meta: { ...(searchWslS7fL7Oy2YUv5_e6dq5nuHI226hZhQOXeOepcf7rYMeta || {}), ...{"middleware":"search-feature"} },
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/search.vue")
  },
  {
    name: "search___en",
    path: "/en/search",
    meta: { ...(searchWslS7fL7Oy2YUv5_e6dq5nuHI226hZhQOXeOepcf7rYMeta || {}), ...{"middleware":"search-feature"} },
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/search.vue")
  },
  {
    name: "search___fr",
    path: "/fr/search",
    meta: { ...(searchWslS7fL7Oy2YUv5_e6dq5nuHI226hZhQOXeOepcf7rYMeta || {}), ...{"middleware":"search-feature"} },
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/search.vue")
  },
  {
    name: "barcode___de",
    path: "/de/barcode",
    meta: barcode_DGUVGXuotZOEcmsn9Snc_452s_dcZRTqCBcrFMFPp7YUMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/barcode.vue")
  },
  {
    name: "barcode___en",
    path: "/en/barcode",
    meta: barcode_DGUVGXuotZOEcmsn9Snc_452s_dcZRTqCBcrFMFPp7YUMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/barcode.vue")
  },
  {
    name: "barcode___fr",
    path: "/fr/barcode",
    meta: barcode_DGUVGXuotZOEcmsn9Snc_452s_dcZRTqCBcrFMFPp7YUMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/barcode.vue")
  },
  {
    name: "c___de",
    path: "/de/c",
    meta: indexG0ccNzubwAUXCDswNT4ozpH7SPsY8PsQHFKywq00jxQMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/c/index.vue")
  },
  {
    name: "c___en",
    path: "/en/c",
    meta: indexG0ccNzubwAUXCDswNT4ozpH7SPsY8PsQHFKywq00jxQMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/c/index.vue")
  },
  {
    name: "c___fr",
    path: "/fr/c",
    meta: indexG0ccNzubwAUXCDswNT4ozpH7SPsY8PsQHFKywq00jxQMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/c/index.vue")
  },
  {
    name: "imprint___de",
    path: "/de/imprint",
    meta: imprint71qypTYtBc3Ic_80U98xOqEU0RfwswY2yx0AXjYLZzEMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/imprint.vue")
  },
  {
    name: "imprint___en",
    path: "/en/imprint",
    meta: imprint71qypTYtBc3Ic_80U98xOqEU0RfwswY2yx0AXjYLZzEMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/imprint.vue")
  },
  {
    name: "imprint___fr",
    path: "/fr/imprint",
    meta: imprint71qypTYtBc3Ic_80U98xOqEU0RfwswY2yx0AXjYLZzEMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/imprint.vue")
  },
  {
    name: "welcome___de",
    path: "/de/welcome",
    meta: welcomeDUPMzS8BwkYMnVrp0orZWYOSpn_45xNLZyla1LSRzSfO0Meta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/welcome.vue")
  },
  {
    name: "welcome___en",
    path: "/en/welcome",
    meta: welcomeDUPMzS8BwkYMnVrp0orZWYOSpn_45xNLZyla1LSRzSfO0Meta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/welcome.vue")
  },
  {
    name: "welcome___fr",
    path: "/fr/welcome",
    meta: welcomeDUPMzS8BwkYMnVrp0orZWYOSpn_45xNLZyla1LSRzSfO0Meta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/welcome.vue")
  },
  {
    name: "register___de",
    path: "/de/register",
    meta: registeraY3oxUg8IyHkqpeqybP1GRdyYY4fSjkfYATUje6rZGAMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/register.vue")
  },
  {
    name: "register___en",
    path: "/en/register",
    meta: registeraY3oxUg8IyHkqpeqybP1GRdyYY4fSjkfYATUje6rZGAMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/register.vue")
  },
  {
    name: "register___fr",
    path: "/fr/register",
    meta: registeraY3oxUg8IyHkqpeqybP1GRdyYY4fSjkfYATUje6rZGAMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/register.vue")
  },
  {
    name: "campaigns___de",
    path: "/de/campaigns",
    meta: campaignsNmd6WuNpr5G1JgGVn5KV20dkf9DSMPH_45ZkUkNG1ZtVsMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/campaigns.vue")
  },
  {
    name: "campaigns___en",
    path: "/en/campaigns",
    meta: campaignsNmd6WuNpr5G1JgGVn5KV20dkf9DSMPH_45ZkUkNG1ZtVsMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/campaigns.vue")
  },
  {
    name: "campaigns___fr",
    path: "/fr/campaigns",
    meta: campaignsNmd6WuNpr5G1JgGVn5KV20dkf9DSMPH_45ZkUkNG1ZtVsMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/campaigns.vue")
  },
  {
    name: "suppliers___de",
    path: "/de/suppliers",
    meta: suppliersPV7R7IjtwKPaVmQQlBk9vshNUFtcC4qicvIbrv_45hSYMMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/suppliers.vue")
  },
  {
    name: "suppliers___en",
    path: "/en/suppliers",
    meta: suppliersPV7R7IjtwKPaVmQQlBk9vshNUFtcC4qicvIbrv_45hSYMMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/suppliers.vue")
  },
  {
    name: "suppliers___fr",
    path: "/fr/suppliers",
    meta: suppliersPV7R7IjtwKPaVmQQlBk9vshNUFtcC4qicvIbrv_45hSYMMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/suppliers.vue")
  },
  {
    name: "gutscheine___de",
    path: "/de/gutscheine",
    meta: gutscheiner9mZFQnOuDVRETXIMQti_45hiuDEePY6ILftRJu2uhyWQMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/gutscheine.vue")
  },
  {
    name: "gutscheine___en",
    path: "/en/gutscheine",
    meta: gutscheiner9mZFQnOuDVRETXIMQti_45hiuDEePY6ILftRJu2uhyWQMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/gutscheine.vue")
  },
  {
    name: "gutscheine___fr",
    path: "/fr/gutscheine",
    meta: gutscheiner9mZFQnOuDVRETXIMQti_45hiuDEePY6ILftRJu2uhyWQMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/gutscheine.vue")
  },
  {
    name: "c-slug___de",
    path: "/de/c/:slug(.*)*",
    meta: _91_46_46_46slug_93W3y0W0OoKgVRvZrj5DvVjvLaodRZHzZ2ztaeTudzpcMMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/c/[...slug].vue")
  },
  {
    name: "c-slug___en",
    path: "/en/c/:slug(.*)*",
    meta: _91_46_46_46slug_93W3y0W0OoKgVRvZrj5DvVjvLaodRZHzZ2ztaeTudzpcMMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/c/[...slug].vue")
  },
  {
    name: "c-slug___fr",
    path: "/fr/c/:slug(.*)*",
    meta: _91_46_46_46slug_93W3y0W0OoKgVRvZrj5DvVjvLaodRZHzZ2ztaeTudzpcMMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/c/[...slug].vue")
  },
  {
    name: "campaign-ims___de",
    path: "/de/campaign/ims",
    meta: ims6ylCxuvkDX7NVqgQc6EygMxNdG5R49KUMeP4q_45FqqSYMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/campaign/ims.vue")
  },
  {
    name: "campaign-ims___en",
    path: "/en/campaign/ims",
    meta: ims6ylCxuvkDX7NVqgQc6EygMxNdG5R49KUMeP4q_45FqqSYMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/campaign/ims.vue")
  },
  {
    name: "campaign-ims___fr",
    path: "/fr/campaign/ims",
    meta: ims6ylCxuvkDX7NVqgQc6EygMxNdG5R49KUMeP4q_45FqqSYMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/campaign/ims.vue")
  },
  {
    name: "datasecurity___de",
    path: "/de/datasecurity",
    meta: datasecurityzuEdVrb7nsZgphF2c4ZaOkV95nQj1ZKJ1IkBhI_45VF_45UMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/datasecurity.vue")
  },
  {
    name: "datasecurity___en",
    path: "/en/datasecurity",
    meta: datasecurityzuEdVrb7nsZgphF2c4ZaOkV95nQj1ZKJ1IkBhI_45VF_45UMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/datasecurity.vue")
  },
  {
    name: "datasecurity___fr",
    path: "/fr/datasecurity",
    meta: datasecurityzuEdVrb7nsZgphF2c4ZaOkV95nQj1ZKJ1IkBhI_45VF_45UMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/datasecurity.vue")
  },
  {
    name: "fallback___de",
    path: "/de/:fallback(.*)*",
    meta: _91_46_46_46fallback_93L6DDBjPIlSnzFeogg2rq2wROjULnmv7xlAbsS7us6AQMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/[...fallback].vue")
  },
  {
    name: "fallback___en",
    path: "/en/:fallback(.*)*",
    meta: _91_46_46_46fallback_93L6DDBjPIlSnzFeogg2rq2wROjULnmv7xlAbsS7us6AQMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/[...fallback].vue")
  },
  {
    name: "fallback___fr",
    path: "/fr/:fallback(.*)*",
    meta: _91_46_46_46fallback_93L6DDBjPIlSnzFeogg2rq2wROjULnmv7xlAbsS7us6AQMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/[...fallback].vue")
  },
  {
    name: "campaign-heel___de",
    path: "/de/campaign/heel",
    meta: heelFHh_Tuy1gH75Q8fhRZr92VQ3pTYAkYMaX_45N_p12S0ZQMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/campaign/heel.vue")
  },
  {
    name: "campaign-heel___en",
    path: "/en/campaign/heel",
    meta: heelFHh_Tuy1gH75Q8fhRZr92VQ3pTYAkYMaX_45N_p12S0ZQMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/campaign/heel.vue")
  },
  {
    name: "campaign-heel___fr",
    path: "/fr/campaign/heel",
    meta: heelFHh_Tuy1gH75Q8fhRZr92VQ3pTYAkYMaX_45N_p12S0ZQMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/campaign/heel.vue")
  },
  {
    name: "hybrid-search___de",
    path: "/de/hybrid-search",
    meta: { ...(hybrid_45searchLQtuDiwtc_45CJSjcazX1CdDU5nUw7olJuH3byw_tJUZ4Meta || {}), ...{"middleware":"hybrid-search-feature"} },
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/hybrid-search.vue")
  },
  {
    name: "hybrid-search___en",
    path: "/en/hybrid-search",
    meta: { ...(hybrid_45searchLQtuDiwtc_45CJSjcazX1CdDU5nUw7olJuH3byw_tJUZ4Meta || {}), ...{"middleware":"hybrid-search-feature"} },
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/hybrid-search.vue")
  },
  {
    name: "hybrid-search___fr",
    path: "/fr/hybrid-search",
    meta: { ...(hybrid_45searchLQtuDiwtc_45CJSjcazX1CdDU5nUw7olJuH3byw_tJUZ4Meta || {}), ...{"middleware":"hybrid-search-feature"} },
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/hybrid-search.vue")
  },
  {
    name: "order-history___de",
    path: "/de/order-history",
    meta: order_45historyeOjy2A_gUtPw5d7CVYR1gL9WvefpWcxftLgNgKoQsOMMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/order-history.vue")
  },
  {
    name: "order-history___en",
    path: "/en/order-history",
    meta: order_45historyeOjy2A_gUtPw5d7CVYR1gL9WvefpWcxftLgNgKoQsOMMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/order-history.vue")
  },
  {
    name: "order-history___fr",
    path: "/fr/order-history",
    meta: order_45historyeOjy2A_gUtPw5d7CVYR1gL9WvefpWcxftLgNgKoQsOMMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/order-history.vue")
  },
  {
    name: "s-orders-id___de",
    path: "/de/s/orders/:id()",
    meta: _91id_93VfZt1YHSzQkzYa5vAq_16pPjJj5MTHrP7IpjA8eJOPsMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/s/orders/[id].vue")
  },
  {
    name: "s-orders-id___en",
    path: "/en/s/orders/:id()",
    meta: _91id_93VfZt1YHSzQkzYa5vAq_16pPjJj5MTHrP7IpjA8eJOPsMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/s/orders/[id].vue")
  },
  {
    name: "s-orders-id___fr",
    path: "/fr/s/orders/:id()",
    meta: _91id_93VfZt1YHSzQkzYa5vAq_16pPjJj5MTHrP7IpjA8eJOPsMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/s/orders/[id].vue")
  },
  {
    name: "supplier-id___de",
    path: "/de/supplier/:id()",
    meta: _91id_93Ssj5Z8DVMWnm_45B_FTgtXMiNH3dcf_LNUcl_2F3UPsXAMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/supplier/[id].vue")
  },
  {
    name: "supplier-id___en",
    path: "/en/supplier/:id()",
    meta: _91id_93Ssj5Z8DVMWnm_45B_FTgtXMiNH3dcf_LNUcl_2F3UPsXAMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/supplier/[id].vue")
  },
  {
    name: "supplier-id___fr",
    path: "/fr/supplier/:id()",
    meta: _91id_93Ssj5Z8DVMWnm_45B_FTgtXMiNH3dcf_LNUcl_2F3UPsXAMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/supplier/[id].vue")
  },
  {
    name: "campaign-hills___de",
    path: "/de/campaign/hills",
    meta: hillsf31UG3z877OU6aydC_4516lub6cam5s9FuM8UbICDLPtsMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/campaign/hills.vue")
  },
  {
    name: "campaign-hills___en",
    path: "/en/campaign/hills",
    meta: hillsf31UG3z877OU6aydC_4516lub6cam5s9FuM8UbICDLPtsMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/campaign/hills.vue")
  },
  {
    name: "campaign-hills___fr",
    path: "/fr/campaign/hills",
    meta: hillsf31UG3z877OU6aydC_4516lub6cam5s9FuM8UbICDLPtsMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/campaign/hills.vue")
  },
  {
    name: "reset-password___de",
    path: "/de/reset-password",
    meta: reset_45passwordIuBeOF7UeEPo6ocQ_45JZJTEMNHznKS7C_45j09hi2CjtAUMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/reset-password.vue")
  },
  {
    name: "reset-password___en",
    path: "/en/reset-password",
    meta: reset_45passwordIuBeOF7UeEPo6ocQ_45JZJTEMNHznKS7C_45j09hi2CjtAUMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/reset-password.vue")
  },
  {
    name: "reset-password___fr",
    path: "/fr/reset-password",
    meta: reset_45passwordIuBeOF7UeEPo6ocQ_45JZJTEMNHznKS7C_45j09hi2CjtAUMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/reset-password.vue")
  },
  {
    name: "account-profile___de",
    path: "/de/account/profile",
    meta: profileu9nNpdn7WyO4te18Sd6wH27AaG0hqjsq59ybAhSlMxYMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/account/profile.vue")
  },
  {
    name: "account-profile___en",
    path: "/en/account/profile",
    meta: profileu9nNpdn7WyO4te18Sd6wH27AaG0hqjsq59ybAhSlMxYMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/account/profile.vue")
  },
  {
    name: "account-profile___fr",
    path: "/fr/account/profile",
    meta: profileu9nNpdn7WyO4te18Sd6wH27AaG0hqjsq59ybAhSlMxYMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/account/profile.vue")
  },
  {
    name: "campaign-tessie___de",
    path: "/de/campaign/tessie",
    meta: tessieb280MR3BX8hp8SNFia3l9C4ZngBau8m58R_45yYvh5XyQMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/campaign/tessie.vue")
  },
  {
    name: "campaign-tessie___en",
    path: "/en/campaign/tessie",
    meta: tessieb280MR3BX8hp8SNFia3l9C4ZngBau8m58R_45yYvh5XyQMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/campaign/tessie.vue")
  },
  {
    name: "campaign-tessie___fr",
    path: "/fr/campaign/tessie",
    meta: tessieb280MR3BX8hp8SNFia3l9C4ZngBau8m58R_45yYvh5XyQMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/campaign/tessie.vue")
  },
  {
    name: "forgot-password___de",
    path: "/de/forgot-password",
    meta: forgot_45passwordBrE8DfLG4muBQPIn2F5_r5NfrL3HhMFlIs_15I9ZaOkMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/forgot-password.vue")
  },
  {
    name: "forgot-password___en",
    path: "/en/forgot-password",
    meta: forgot_45passwordBrE8DfLG4muBQPIn2F5_r5NfrL3HhMFlIs_15I9ZaOkMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/forgot-password.vue")
  },
  {
    name: "forgot-password___fr",
    path: "/fr/forgot-password",
    meta: forgot_45passwordBrE8DfLG4muBQPIn2F5_r5NfrL3HhMFlIs_15I9ZaOkMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/forgot-password.vue")
  },
  {
    name: "product-favorites___de",
    path: "/de/product-favorites",
    meta: product_45favoritesjPoYwjLYiOfpGIdFqo8spcKjVfyAew4sJx0nIO6JbJEMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/product-favorites.vue")
  },
  {
    name: "product-favorites___en",
    path: "/en/product-favorites",
    meta: product_45favoritesjPoYwjLYiOfpGIdFqo8spcKjVfyAew4sJx0nIO6JbJEMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/product-favorites.vue")
  },
  {
    name: "product-favorites___fr",
    path: "/fr/product-favorites",
    meta: product_45favoritesjPoYwjLYiOfpGIdFqo8spcKjVfyAew4sJx0nIO6JbJEMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/product-favorites.vue")
  },
  {
    name: "account-references___de",
    path: "/de/account/references",
    meta: references14hKF4c9x4KtiJsgq2XRqKcNn9uzwgp5yP_45FWgVQ_45PEMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/account/references.vue")
  },
  {
    name: "account-references___en",
    path: "/en/account/references",
    meta: references14hKF4c9x4KtiJsgq2XRqKcNn9uzwgp5yP_45FWgVQ_45PEMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/account/references.vue")
  },
  {
    name: "account-references___fr",
    path: "/fr/account/references",
    meta: references14hKF4c9x4KtiJsgq2XRqKcNn9uzwgp5yP_45FWgVQ_45PEMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/account/references.vue")
  },
  {
    name: "campaign-dehinexxa___de",
    path: "/de/campaign/dehinexxa",
    meta: dehinexxa_45Rs1XOvAyNQtRw7loaVbf6JLdq3razC0_45V99596SjX0Meta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/campaign/dehinexxa.vue")
  },
  {
    name: "campaign-dehinexxa___en",
    path: "/en/campaign/dehinexxa",
    meta: dehinexxa_45Rs1XOvAyNQtRw7loaVbf6JLdq3razC0_45V99596SjX0Meta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/campaign/dehinexxa.vue")
  },
  {
    name: "campaign-dehinexxa___fr",
    path: "/fr/campaign/dehinexxa",
    meta: dehinexxa_45Rs1XOvAyNQtRw7loaVbf6JLdq3razC0_45V99596SjX0Meta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/campaign/dehinexxa.vue")
  },
  {
    name: "clinic-chain___de",
    path: "/de/clinic-chain",
    meta: indexHZNxFXVUC3W8nyDimd6fbyG86czmf8BLEquc_AEVdFYMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/clinic-chain/index.vue")
  },
  {
    name: "clinic-chain___en",
    path: "/en/clinic-chain",
    meta: indexHZNxFXVUC3W8nyDimd6fbyG86czmf8BLEquc_AEVdFYMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/clinic-chain/index.vue")
  },
  {
    name: "clinic-chain___fr",
    path: "/fr/clinic-chain",
    meta: indexHZNxFXVUC3W8nyDimd6fbyG86czmf8BLEquc_AEVdFYMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/clinic-chain/index.vue")
  },
  {
    name: "order-confirm-id___de",
    path: "/de/order-confirm/:id()",
    meta: _91id_93_45hZx5NyrR1_sSTQPwpsEYgKUmS_6OhgdWqKWbR2f6c4Meta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/order-confirm/[id].vue")
  },
  {
    name: "order-confirm-id___en",
    path: "/en/order-confirm/:id()",
    meta: _91id_93_45hZx5NyrR1_sSTQPwpsEYgKUmS_6OhgdWqKWbR2f6c4Meta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/order-confirm/[id].vue")
  },
  {
    name: "order-confirm-id___fr",
    path: "/fr/order-confirm/:id()",
    meta: _91id_93_45hZx5NyrR1_sSTQPwpsEYgKUmS_6OhgdWqKWbR2f6c4Meta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/order-confirm/[id].vue")
  },
  {
    name: "campaign-domespharma2___de",
    path: "/de/campaign/domespharma2",
    meta: domespharma2nBZUb50oDFW5D8NEtPuByla98SqR6_QCPuo6QM8NQQcMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/campaign/domespharma2.vue")
  },
  {
    name: "campaign-domespharma2___en",
    path: "/en/campaign/domespharma2",
    meta: domespharma2nBZUb50oDFW5D8NEtPuByla98SqR6_QCPuo6QM8NQQcMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/campaign/domespharma2.vue")
  },
  {
    name: "campaign-domespharma2___fr",
    path: "/fr/campaign/domespharma2",
    meta: domespharma2nBZUb50oDFW5D8NEtPuByla98SqR6_QCPuo6QM8NQQcMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/campaign/domespharma2.vue")
  },
  {
    name: "campaign-domespharma3___de",
    path: "/de/campaign/domespharma3",
    meta: domespharma3oHZ0cutLV2H6zRXgZK0hiGu0_45ALXXh_45uxlPC5RatEg0Meta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/campaign/domespharma3.vue")
  },
  {
    name: "campaign-domespharma3___en",
    path: "/en/campaign/domespharma3",
    meta: domespharma3oHZ0cutLV2H6zRXgZK0hiGu0_45ALXXh_45uxlPC5RatEg0Meta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/campaign/domespharma3.vue")
  },
  {
    name: "campaign-domespharma3___fr",
    path: "/fr/campaign/domespharma3",
    meta: domespharma3oHZ0cutLV2H6zRXgZK0hiGu0_45ALXXh_45uxlPC5RatEg0Meta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/campaign/domespharma3.vue")
  },
  {
    name: "campaign-domespharma4___de",
    path: "/de/campaign/domespharma4",
    meta: domespharma4lE2mVDh4ttE1NrZbCW576oTFjG8P2h74SdzsHCpLh1MMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/campaign/domespharma4.vue")
  },
  {
    name: "campaign-domespharma4___en",
    path: "/en/campaign/domespharma4",
    meta: domespharma4lE2mVDh4ttE1NrZbCW576oTFjG8P2h74SdzsHCpLh1MMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/campaign/domespharma4.vue")
  },
  {
    name: "campaign-domespharma4___fr",
    path: "/fr/campaign/domespharma4",
    meta: domespharma4lE2mVDh4ttE1NrZbCW576oTFjG8P2h74SdzsHCpLh1MMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/campaign/domespharma4.vue")
  },
  {
    name: "hybrid-search-staging___de",
    path: "/de/hybrid-search-staging",
    meta: { ...(hybrid_45search_45stagingHC0rELwWxwMZxgh2i0345oXlmZOirGUreMT3pWUJD8MMeta || {}), ...{"middleware":"staging-only"} },
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/hybrid-search-staging.vue")
  },
  {
    name: "hybrid-search-staging___en",
    path: "/en/hybrid-search-staging",
    meta: { ...(hybrid_45search_45stagingHC0rELwWxwMZxgh2i0345oXlmZOirGUreMT3pWUJD8MMeta || {}), ...{"middleware":"staging-only"} },
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/hybrid-search-staging.vue")
  },
  {
    name: "hybrid-search-staging___fr",
    path: "/fr/hybrid-search-staging",
    meta: { ...(hybrid_45search_45stagingHC0rELwWxwMZxgh2i0345oXlmZOirGUreMT3pWUJD8MMeta || {}), ...{"middleware":"staging-only"} },
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/hybrid-search-staging.vue")
  },
  {
    name: "country-fallback___de",
    path: "/de/:country()/:fallback(.*)*",
    meta: _91_46_46_46fallback_93VQE8_wkYi1C5zByz6AyriJ6VGo_456ghPNLEHguVOVTSAMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/[country]/[...fallback].vue")
  },
  {
    name: "country-fallback___en",
    path: "/en/:country()/:fallback(.*)*",
    meta: _91_46_46_46fallback_93VQE8_wkYi1C5zByz6AyriJ6VGo_456ghPNLEHguVOVTSAMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/[country]/[...fallback].vue")
  },
  {
    name: "country-fallback___fr",
    path: "/fr/:country()/:fallback(.*)*",
    meta: _91_46_46_46fallback_93VQE8_wkYi1C5zByz6AyriJ6VGo_456ghPNLEHguVOVTSAMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/[country]/[...fallback].vue")
  },
  {
    name: "product-supplier-id___de",
    path: "/de/product/:supplier()/:id()",
    meta: _91id_93JScHRPnUpAFRUm4_G_45AAhlA11mNv7Lq8xNK_459SeqYeMMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/product/[supplier]/[id].vue")
  },
  {
    name: "product-supplier-id___en",
    path: "/en/product/:supplier()/:id()",
    meta: _91id_93JScHRPnUpAFRUm4_G_45AAhlA11mNv7Lq8xNK_459SeqYeMMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/product/[supplier]/[id].vue")
  },
  {
    name: "product-supplier-id___fr",
    path: "/fr/product/:supplier()/:id()",
    meta: _91id_93JScHRPnUpAFRUm4_G_45AAhlA11mNv7Lq8xNK_459SeqYeMMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/product/[supplier]/[id].vue")
  },
  {
    name: "clinic-chain-affiliation___de",
    path: "/de/clinic-chain/affiliation",
    meta: affiliation7SbgaERsXbH3O_451uoyXxp4mAFfsh5L80TkVoZ5v9X4cMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/clinic-chain/affiliation.vue")
  },
  {
    name: "clinic-chain-affiliation___en",
    path: "/en/clinic-chain/affiliation",
    meta: affiliation7SbgaERsXbH3O_451uoyXxp4mAFfsh5L80TkVoZ5v9X4cMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/clinic-chain/affiliation.vue")
  },
  {
    name: "clinic-chain-affiliation___fr",
    path: "/fr/clinic-chain/affiliation",
    meta: affiliation7SbgaERsXbH3O_451uoyXxp4mAFfsh5L80TkVoZ5v9X4cMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/apps/shop-frontend/pages/clinic-chain/affiliation.vue")
  }
]